// Kept free of zod and dayjs so light modules (and the widget) can parse times without them.
export function parseTimeString(time: string): readonly [number, number, number] | null {
  const [hours, minutes, seconds = 0] = time.split(':').map(Number);
  if (
    hours === undefined ||
    minutes === undefined ||
    !Number.isInteger(hours) ||
    !Number.isInteger(minutes) ||
    !Number.isInteger(seconds) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59 ||
    seconds < 0 ||
    seconds > 59
  ) {
    return null;
  }

  return [hours, minutes, seconds] as const;
}
